import { Box, Chip, Divider, Typography } from "@mui/material";
import styles from "./style.module.css";
import { useTheme } from "../../../../../../context/themeContext";
import trash from "../../../../../../assets/images/trash-icons/trash-02.svg";
import trashDark from "../../../../../../assets/images/trash-icons/trash-02-dark.svg";
import { RoomOutlined } from "@mui/icons-material";
import { useState } from "react";
import DeleteConfirmation from "./delete-confirmation";
import { useNavigate } from "react-router-dom";
import { creator_withdrew } from "../../../../../../helpers/emails";
import { useDispatch, useSelector } from "react-redux";
import useManageProjects from "../../../../../../hooks/useManageProjects";
import { setApplications } from "../../../../../../store/slices/profile/manageProjectsSlice";

const Card = ({ project }) => {
  const { theme, darkMode } = useTheme();
  const user = useSelector((state) => state.user.value);
  const dispatch = useDispatch();
  const { applications } = useSelector((state) => state.manageProjects);
  const { handleRemoveApplication } = useManageProjects();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleRemove = async (project) => {
    const updatedApplications = applications.filter(
      (app) => app.project_id !== project.project_id
    );
    dispatch(setApplications(updatedApplications));

    handleRemoveApplication(project);
    await creator_withdrew(user?.id, project?.project_id);
  };

  return (
    <>
      <DeleteConfirmation
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        onDelete={handleRemove}
        project={project}
      />
      <Box
        className={styles.card}
        sx={{
          bgcolor: darkMode ? "#333" : theme.palette.lightgrey.lightgrey00,
        }}
      >
        <Box
          className={styles.pic}
          onClick={() => navigate(`/projects/${project.project_id}`)}
          sx={{
            cursor: "pointer",
            backgroundImage: `url(${project.project_cover_image})`,
          }}
        ></Box>
        <Box className={styles.content}>
          <Box className={styles.frame}>
            <Typography
              sx={{
                display: "flex",
                alignSelf: "stretch",
                color: darkMode
                  ? theme.palette.darkgrey.darkgreybody50
                  : theme.palette.darkgrey.darkgrey600,
                fontSize: "16px",
                fontWeight: "700",
              }}
            >
              {project.title}
            </Typography>
            <Box className={styles.frame2}>
              <Chip
                label={project.category}
                sx={{
                  height: "auto",
                  padding: "3px 12px",
                  bgcolor:
                    (project.category === "Brand" && "#EC7508") ||
                    (project.category === "Cause" && "#05B240") ||
                    (project.category === "Creator" && "#09B999") ||
                    (project.category === "Media" && "#B90988"),
                  color: "#FFF",
                  textTransform: "capitalize",
                  fontSize: "12px",
                }}
              />
              <Chip
                label={project.status}
                sx={{
                  fontSize: "12px",
                  height: "auto",
                  padding: "3px 12px",
                  bgcolor: theme.palette.success.dark,
                  color: "#FFF",
                  textTransform: "capitalize",
                }}
              />
            </Box>
          </Box>
          <Box className={styles.action}>
            <Box className={styles.locations}>
              <RoomOutlined
                sx={{
                  width: "16px",
                  height: "16px",
                  color: theme.palette.darkgrey.darkgrey500,
                }}
              />
              <Typography
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: "1",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: theme.palette.darkgrey.darkgrey500,
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                {project.location_name === ""
                  ? "Remote"
                  : project.location_name}
              </Typography>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box
              className={styles.remove}
              onClick={() => setIsDeleteModalOpen(true)}
            >
              <img src={darkMode ? trashDark : trash} alt="remove" />
              <Typography
                variant="body1"
                color={theme.palette.darkgrey.darkgrey400}
                sx={{
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                Remove
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Card;
